// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-blue{
    background-color: #5d9cec;
}
.font-nav{
    font-family: 'Lato', sans-serif;
    font-size: 16px !important;
    line-height: 1.52857143;
    letter-spacing: .025em;
    font-weight: normal;
}
.nav-link.active {
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/app/h-nav-menu/h-nav-menu.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".bg-blue{\r\n    background-color: #5d9cec;\r\n}\r\n.font-nav{\r\n    font-family: 'Lato', sans-serif;\r\n    font-size: 16px !important;\r\n    line-height: 1.52857143;\r\n    letter-spacing: .025em;\r\n    font-weight: normal;\r\n}\r\n.nav-link.active {\r\n    font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
